import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { allAvailableEventTypes } from 'src/consumer/constants'
import { GenericModalHeadlineLevelTwo, StyledEventReactSelect } from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import SelectABundle from 'src/mentor/components/MentorEventsPage/components/bundle/SelectABundle'
import ShowDetailsOfSelectedPlan from 'src/mentor/components/MentorEventsPage/components/eventsListing/ShowDetailsOfSelectedPlan'
import { ChangesWillNotBeSavedButton, SubscriptionOption, SubscriptionValue } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'


export default function PricingConfiguration({
  basicEventObject,
  viewPriceCountry,
  setViewPriceCountry,
  oneOnOnePlans,
  bundlePacks,
  unSecureSetupData,
  changePlan,
  handleEditOneOnOnePlan,
  setBundle,
  refreshBundlePacks,
  mentorProfileData,
  isDisabled,
}) {
  if (basicEventObject?.free) {
    return null
  }

  return (
    <div>
      <GenericModalHeadlineLevelTwo>Set Session Pricing</GenericModalHeadlineLevelTwo>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <span style={{ flexShrink: '0' }}> Showing prices for </span>
        <CustomSelect
          id="viewPriceCountry"
          value={viewPriceCountry}
          options={[
            ...(unSecureSetupData?.metaCountries || [])?.sort((a, b) =>
              a?.name?.localeCompare(b.name),
            ),
          ]}
          customComponent={StyledEventReactSelect}
          classNamePrefix="react-select"
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          placeholder="Change"
          onChangeEvent={(event) => {
            setViewPriceCountry(event.target.value)
          }}
          selectType={selectTypes.string}
        />
      </div>
      <div
        style={{
          padding: '10px 0px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        {basicEventObject?.type !== allAvailableEventTypes?.webinar ? (
          <CustomSelect
            value={basicEventObject?.subscriptionPlanId}
            options={[
              { id: 'create-plan', finalPrice: 'Create Plan' },
              ...(oneOnOnePlans || [])?.filter(
                (plan) => plan?.mentorId === mentorProfileData?.id || !plan?.mentorId,
              ),
            ]}
            components={{ Option: SubscriptionOption, SingleValue: SubscriptionValue }}
            metaCountries={unSecureSetupData?.metaCountries}
            viewPriceCountry={viewPriceCountry}
            customComponent={StyledEventReactSelect}
            getOptionLabel={(option) =>
              option?.id === 'create-plan'
                ? option?.finalPrice
                : `${
                    unSecureSetupData?.metaCountries?.find(
                      (countryItem) => countryItem?.currency === option?.currency,
                    )?.currencySymbol
                  } ${option?.finalPrice}`
            }
            getOptionValue={(option) => option?.id}
            onChangeEvent={changePlan}
            selectType={selectTypes.string}
            isDisabled={isDisabled}
          />
        ) : (
          <CustomSelect
            value={basicEventObject?.pricingPlanId}
            options={[
              { id: 'create-plan', finalPrice: 'Create Plan' },
              ...(oneOnOnePlans || [])?.filter(
                (plan) => plan?.mentorId === mentorProfileData?.id || !plan?.mentorId,
              ),
            ]}
            components={{ Option: SubscriptionOption, SingleValue: SubscriptionValue }}
            metaCountries={unSecureSetupData?.metaCountries}
            viewPriceCountry={viewPriceCountry}
            customComponent={StyledEventReactSelect}
            getOptionLabel={(option) =>
              option?.id === 'create-plan'
                ? option?.finalPrice
                : `${
                    unSecureSetupData?.metaCountries?.find(
                      (countryItem) => countryItem?.currency === option?.currency,
                    )?.currencySymbol
                  } ${option?.finalPrice}`
            }
            getOptionValue={(option) => option?.id}
            onChangeEvent={changePlan}
            selectType={selectTypes.string}
            isDisabled={isDisabled}
          />
        )}
        {!!oneOnOnePlans?.find((plan) =>
          basicEventObject?.type !== allAvailableEventTypes?.webinar
            ? plan?.id === basicEventObject?.subscriptionPlanId
            : plan?.id === basicEventObject?.pricingPlanId,
        )?.mentorId && (
          <ChangesWillNotBeSavedButton onClick={handleEditOneOnOnePlan}>
            Edit
          </ChangesWillNotBeSavedButton>
        )}
      </div>
      <ShowDetailsOfSelectedPlan
        planData={oneOnOnePlans?.find((item) =>
          basicEventObject?.type !== allAvailableEventTypes?.webinar
            ? item?.id === basicEventObject?.subscriptionPlanId
            : item?.id === basicEventObject?.pricingPlanId,
        )}
        unSecureSetupData={unSecureSetupData}
      />
      <SelectABundle
        selectedPlanId={basicEventObject?.subscriptionPlanId || basicEventObject?.pricingPlanId}
        allOneOnOnes={oneOnOnePlans}
        allBundles={bundlePacks}
        refreshBundles={refreshBundlePacks}
        selectedBundleIds={basicEventObject?.bundlePlanIds}
        setSelectedBundleIds={setBundle}
        mentorProfileData={mentorProfileData}
        isDisabled={isDisabled}
      />
    </div>
  )
}
